module.exports = __webpack_public_path__ + "static/media/learn-german.e799ca28.jpg";